import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;
// Helper function to escape HTML entities (prevents XSS in document.write)
const escapeHtml = (text) => {
  if (!text) return '';
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, (char) => map[char]);
};

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    deleteFile: async ({ commit }, uuid) => {
      try {
        await api({ requiresAuth: true }).delete(`/v1/media/${uuid}`);
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.fileDeletedSuccessfully"),
        });
      } catch (err) {
        console.error(err);
      }
    },

    renameFile: async ({ commit }, { uuid, name }) => {
      try {
        await api({ requiresAuth: true }).patch(`/v1/media/${uuid}`, {
          file_name: name,
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.fileUpdatedSuccessfully"),
        });
      } catch (err) {
        console.error(err);
      }
    },

    changeFileProperties: async (_, { uuid, isApp, isPrivate }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/media/${uuid}/app/properties`,
          {
            is_private: isPrivate,
            is_app: isApp,
          }
        );
      } catch (err) {
        console.error(err);
      }
    },

    openFile: async (_, file) => { 
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/media/${file.uuid}`,
          {
            responseType: "blob",
          }
        );

        const mimeType = response.data.type || file.mime_type || 'application/octet-stream';
        const fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: mimeType })
        );
 
        const isViewable = mimeType === "application/pdf" || 
                          mimeType.startsWith("image/");

        if (isViewable) { 
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            const escapedFileName = escapeHtml(file.file_name);
            newWindow.document.write(`
              <!DOCTYPE html>
              <html>
                <head>
                  <title>${escapedFileName}</title>
                  <style>
                    body { margin: 0; overflow: hidden; }
                    iframe { border: none; width: 100vw; height: 100vh; }
                  </style>
                </head>
                <body>
                  <iframe src="${fileURL}"></iframe>
                </body>
              </html>
            `);
            newWindow.document.close();
          }
        } else { 
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file.file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        }
      } catch (err) {
        console.error(err);
      }
    },

    downloadFile: async (_, file) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          `/v1/media/${file.uuid}`,
          {
            responseType: "blob",
          }
        );

        const mimeType = response.data.type || file.mime_type || 'application/octet-stream';
        const fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: mimeType })
        );
 
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", file.file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
